// extracted by mini-css-extract-plugin
export default {"cls1":"Oe9WIwaLvdyNLvG847fI","cls2":"uLC3v1YRxxMatsQdDeUH Oe9WIwaLvdyNLvG847fI"};